import React from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import {
  CheckCircle as CheckCircleIcon,
  RemoveCircle as RemoveCircleIcon,
} from '@mui/icons-material';

export default function MethodMatrixDataTable({
  methods,
  currencies,
  methodNames,
}) {
  const getTableCellValue = (method) => {
    if (!method) return '-';

    const { methodStatus, gatewayName } = method;

    const isActive = methodStatus === 1;

    return (
      <Box>
        {isActive ? (
          <CheckCircleIcon color="success" />
        ) : (
          <RemoveCircleIcon color="disabled" />
        )}
        <Box>
          <Typography
            color={isActive ? 'green' : 'grey'}
            variant="caption">
            {gatewayName}
          </Typography>
        </Box>
      </Box>
    );
  };

  return (
    <TableContainer sx={{ maxHeight: 440 }}>
      <Table
        stickyHeader
        size="small">
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: '160px' }}>Method Name</TableCell>
            {currencies.map((currency) => (
              <TableCell
                key={currency}
                align="center">
                {currency}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {methodNames.map((methodName, i) => {
            const rowBorderStyles =
              methodNames.length - 1 === i ? { borderBottom: 0 } : {};
            return (
              <TableRow key={methodName}>
                <TableCell sx={rowBorderStyles}>{methodName}</TableCell>
                {currencies.map((currency) => {
                  const method = methods.find(
                    (item) =>
                      item.methodName === methodName &&
                      item.currencyCode === currency,
                  );
                  return (
                    <TableCell
                      key={currency}
                      align="center"
                      sx={rowBorderStyles}>
                      {getTableCellValue(method)}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
